import BusinessImages from 'components/business/BusinessImages';

export default function BusinessPhotos() {
  return (
    <>
      <BusinessImages hideButton />
    </>
  );
}
